import { ArrowRight, CheckCircle, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function VendorProcurementExcellence() {
  const benefits = ["Streamlined vendor selection and onboarding", "Cost-effective supply chain optimization", "Contract management and compliance oversight", "Risk mitigation through strategic partnerships"];
  return <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 text-accent border border-accent/20">
              <TrendingUp className="size-4" />
              <span className="text-sm font-semibold">Supply Chain Excellence</span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              Vendor & Procurement Excellence
            </h1>
            
            <p className="text-lg text-muted-foreground leading-relaxed">
              Navigate the complexities of vendor relationships and supply chain management with expert guidance from Aran Group. We help companies optimize procurement processes, select the right partners, and manage contracts effectively to drive operational efficiency and cost savings.
            </p>

            <div className="space-y-3 pt-4">
              {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex items-start gap-3 group">
                  <CheckCircle className="size-5 text-accent shrink-0 mt-0.5 transition-transform duration-200 group-hover:scale-110" />
                  <span className="text-foreground">{benefit}</span>
                </div>)}
            </div>

            <div className="flex flex-wrap gap-4 pt-6">
              <Link to="/ContactPage">
                <Button size="lg" className="gap-2">
                  Get Started
                  <ArrowRight className="size-4" />
                </Button>
              </Link>
              <Link to="/HomePage">
                <Button variant="outline" size="lg">
                  Learn More
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-accent/5 rounded-2xl blur-3xl" />
            <Card className="relative border-2 hover:shadow-strong transition-all duration-300">
              <CardHeader>
                <CardTitle className="text-2xl">Why Choose Aran Group?</CardTitle>
                <CardDescription>
                  Our turnkey approach to vendor and procurement advisory
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="space-y-4">
                  <div className="flex gap-4">
                    <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                      <svg className="size-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground mb-1">Strategic Vendor Selection</h3>
                      <p className="text-sm text-muted-foreground">
                        Identify and vet vendors aligned with your business goals and operational needs.
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-4">
                    <div className="size-12 rounded-lg bg-secondary/10 flex items-center justify-center shrink-0">
                      <svg className="size-6 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground mb-1">Supply Chain Optimization</h3>
                      <p className="text-sm text-muted-foreground">
                        Streamline operations, reduce costs, and improve delivery timelines.
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-4">
                    <div className="size-12 rounded-lg bg-accent/10 flex items-center justify-center shrink-0">
                      <svg className="size-6 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground mb-1">Contract Management</h3>
                      <p className="text-sm text-muted-foreground">
                        Negotiate favorable terms and ensure compliance across all vendor relationships.
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
              <CardFooter className="border-t pt-6">
                <p className="text-sm text-muted-foreground">
                  <strong className="text-foreground">123 Business Ave, Cityville, State, ZIP</strong> • (123) 456-7890
                </p>
              </CardFooter>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}